<script>
import NavBar from '@/components/Nav-Bar.vue'

export default {
  components: {
    NavBar
  }
}
</script>
<template>
  <div class="container-first c-first">
    <nav-bar></nav-bar>
    <section class="container-main">
      <div class="container-text">
        <h1 class="title">
          Manage your <br />
          grocery shopping <br />
          with <span class="text-primary text-underline">Grub’s up</span>
        </h1>
        <p>
          Grub's up is a smart shopping list application,<br />
          It will create a shopping list with product<br />
          recommendations
        </p>
        <div class="container-downloads">
            <a href="https://testflight.apple.com/join/knoLROk9">
              <img
                width="120"
                height="40"
                src="@/assets/img/apple/download.svg"
                alt="Download on app store"
              />
            </a>
        </div>
      </div>
      <div class="container-meals">
        <img src="@/assets/img/pan.svg" alt="a pan" />
      </div>
    </section>
  </div>
  <div class="c-dark-background">
    <div class="container">
      <section class="container-secondary">
        <img
          class="asset-top"
          src="@/assets/img/onion.svg"
          height="100"
          width="100"
          alt="a phone with grub's up app"
        />
        <img
          class="z-1 asset-phone"
          src="@/assets/img/phone-1.png"
          height="100"
          width="300"
          alt="a phone with grub's up app"
        />
        <div class="circle-asset"></div>
        <div class="block-promo z-1">
          <div class="promo">
            <img src="@/assets/img/pig.svg" alt="a pig" />
            <p>Save money</p>
          </div>
          <div class="promo">
            <img src="@/assets/img/food.svg" alt="a pig" />
            <p>Eat healthy</p>
          </div>
          <div class="promo">
            <img src="@/assets/img/archive.svg" alt="a pig" />
            <p>Organise your life</p>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="container">
    <section class="container-space-btw">
      <img
        class="button-asset z-1"
        height="100"
        width="400"
        src="@/assets/img/human-seat.svg"
        alt="Download on app store"
      />
      <img
        class="z-1 asset-phone"
        src="@/assets/img/phone-1.png"
        height="100"
        width="300"
        alt="a phone with grub's up app"
      />
      <div class="circle-text-asset">
        <p>Update your list to try a new recipe.</p>
      </div>
    </section>
  </div>
  <div class="c-dark-background">
    <div class="container">
      <section class="container-secondary">
        <img
          class="asset-top"
          src="@/assets/img/olive.svg"
          height="100"
          width="100"
          alt="a phone with grub's up app"
        />

        <div class="container-quote-cta">
          <div class="container-quote">
            <img
              alt="Grub's up logo"
              height="120"
              width="120"
              src="@/assets/logo.svg"
            />
            <h2 class="title h1">
              Use the app will cost you
              <span class="text-primary text-underline">$0</span>
            </h2>
          </div>
          <div class="container-downloads">
            <a href="https://testflight.apple.com/join/knoLROk9">
              <img
                width="120"
                height="40"
                src="@/assets/img/apple/download.svg"
                alt="Download on app store"
              />
            </a>
          </div>
        </div>
        <div class="container-circles">
          <div class="circle-plain-2">
            <p>No account needed</p>
          </div>
          <div class="circle-plain">
            <p>Create a list for free</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
